// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19v9I","clinicsSelect":"styles_clinicsSelect__1MM7T"};